import gql from 'graphql-tag';
import { PAGINATION_VIEW_MODEL_FRAGMENT } from 'shared';

import { DEAL_EVENT_ACTIVITY_FRAGMENT } from './fragments/dealEventActivity.fragment';

export const DEAL_ACTIVITY_EVENTS_LISTING = gql`
  query DealActivityEventsListing($input: DealActivityEventsListingInput!) {
    dealActivity {
      result: dealActivityEventsListing(input: $input) {
        error
        success
        items {
          ...DealEventActivityFields
        }
        pagination {
          ...PaginationMetaViewModel
        }
      }
    }
  }
  ${DEAL_EVENT_ACTIVITY_FRAGMENT}
  ${PAGINATION_VIEW_MODEL_FRAGMENT}
`;
